import { useDataCache } from '../context/DataCacheContext';

export const useCachedData = () => {
  const cache = useDataCache();

  const getDataWithStatus = (dataState) => {
    return {
      data: dataState.data,
      loading: dataState.status === 'loading',
      error: dataState.error,
      success: dataState.status === 'success',
      lastUpdated: dataState.lastUpdated
    };
  };

  const isDataLoaded = (dataState) => {
    return dataState.status === 'success' && dataState.data.length > 0;
  };

  return {
    ...cache,
    getDataWithStatus,
    isDataLoaded
  };
};

export { useDataCache };